import BaseClass from "../BaseClass.js";

export default class SubscriptionPlanForm extends BaseClass {
    constructor(element) {
        super(element);

        this.$isLiveToggle = null;
        this.$isPausedToggle = null;
        this.$specialEnableToggle = null;
        this.$basePriceSelects = null;
        this.$specialPriceSelects = null;
        this.$confirmDeactivate = null;
        this.$confirmDeactivateNo = null;
        this.$savePlanBtn = null;
        this.$discountSelect = null;
        this.$minDateSelect = null;
        this.$specialMinPriceInfo = null;

        this.init();
    }

    init() {
        const mySelf = this;

        this.$specialEnableToggle = this.$element.find('[name="special_enable"]');
        this.$specialMinPriceInfo = this.$element.find('[name="special_min_price_info"]');

        // Beginn Live- und Pause-Switch
        this.$isLiveToggle = this.$element.find('[name="is_live"]');
        this.$isPausedToggle = this.$element.find('[name="is_paused"]');
        this.checkPausingPossibleListener = function (event, f, g) {
            mySelf.checkPausingPossible(event, f, g);
        }
        this.$isLiveToggle.on('change', this.checkPausingPossibleListener);
        this.$isPausedToggle.on('change', this.checkPausingPossibleListener);

        this.updateToggleActiveTextListener = function (event) {
            let $currentTarget = $(event.currentTarget);
            mySelf.updateToggleActiveText($currentTarget);
        }
        this.$isLiveToggle.on('change', this.updateToggleActiveTextListener);
        this.$isPausedToggle.on('change', this.updateToggleActiveTextListener);

        this.onUpdateIsLiveListener = function (event) {
            mySelf.onUpdateIsLive(event);
        }
        this.$isLiveToggle.on('change', this.onUpdateIsLiveListener);
        // Ende Live- und Pause-Switch

        this.$basePriceSelects = this.$element.find('select.base-select');
        this.onBaseSelectListener = function (event, f, g) {
            mySelf.onBaseSelect(mySelf, event, f, g);
        }
        this.$basePriceSelects.on('price-select:changed', this.onBaseSelectListener);

        this.$specialPriceSelects = this.$element.find('select.special-select');
        this.onSpecialSelectListener = function (event, f, g) {
            mySelf.onSpecialSelect(mySelf, event, f, g);
        }
        this.$specialPriceSelects.on('change', this.onSpecialSelectListener);

        this.$confirmDeactivate = this.$element.find('.confirm-deactivate');
        this.$confirmDeactivateNo = this.$confirmDeactivate.find('.confirm-no');
        this.onConfirmNoClickListener = function (event) {
            mySelf.onConfirmNoClick(event);
        }
        this.$confirmDeactivateNo.on('click', this.onConfirmNoClickListener);

        this.$savePlanBtn = this.$element.find('.save-plan-btn');
        this.onSaveClickListener = function (event) {
            mySelf.onSaveClick(event);
        }
        this.$savePlanBtn.on('click', this.onSaveClickListener);

        this.$minDateSelect = this.$element.find('[name="special_beginning_at"]');
        this.setDateRangeListener = function (event) {
            let $currentTarget = $(event.currentTarget);
            mySelf.setDateRange($currentTarget);
        }
        this.$minDateSelect.on('change', mySelf.setDateRangeListener);

        this.$discountSelect = this.$element.find('[name="discount_hash"]');
        this.updatePricePreviewListener = function (event) {
            let $currentTarget = $(event.currentTarget);
            mySelf.updatePricePreview.call(mySelf, $currentTarget);
        }
        this.$discountSelect.on('change', this.updatePricePreviewListener);

        this.updateByBasePrices();
        this.initPricePreview();

    }

    checkPausingPossible() {
        const live = this.$isLiveToggle.prop('checked');
        const $container = this.$isPausedToggle.parent();

        if (live) {
            $container.filter('.hidden').removeClass('hidden');
            this.$isPausedToggle.prop('disabled', false);
        } else {
            $container.filter(':not(.hidden)').addClass('hidden');
            this.$isPausedToggle.prop('disabled', true);
        }
    }

    initPricePreview() {
        if (this.$discountSelect != null) {
            this.updatePricePreview(this.$discountSelect);
        }
    }

    onUpdateIsLive() {
        const isLive = this.$isLiveToggle.prop('checked');
        const initialIsLive = this.$isLiveToggle.data('initial');
        if (isLive || !initialIsLive) {
            this.$savePlanBtn.prop('type', 'submit');
        } else {
            this.$savePlanBtn.prop('type', 'button');
        }
    }

    onSaveClick() {
        const isLive = this.$isLiveToggle.prop('checked');
        const initialIsLive = this.$isLiveToggle.data('initial');

        if (isLive || !initialIsLive) {
            this.$confirmDeactivate.filter(':not(.hidden)').addClass('hidden');
            this.$savePlanBtn.filter('.hidden').removeClass('hidden');
        } else {
            this.$confirmDeactivate.filter('.hidden').removeClass('hidden');
            this.$savePlanBtn.filter(':not(.hidden)').addClass('hidden');
        }
    }

    onConfirmNoClick() {
        this.$isLiveToggle.prop('checked', true);
        this.updateToggleActiveText(this.$isLiveToggle);
        this.checkPausingPossible();
        this.onUpdateIsLive();
        this.$confirmDeactivate.filter(':not(.hidden)').addClass('hidden');
        this.$savePlanBtn.filter('.hidden').removeClass('hidden');
    }

    updateToggleActiveText($toggle) {
        const $parent = $toggle.parent();
        const $activatedLabel = $parent.find('.text-activated');
        const $deactivatedLabel = $parent.find('.text-deactivated');

        const active = $toggle.prop('checked');
        if (active) {
            $activatedLabel.filter('.hidden').removeClass('hidden');
            $deactivatedLabel.filter(':not(.hidden)').addClass('hidden');
        } else {
            $deactivatedLabel.filter('.hidden').removeClass('hidden');
            $activatedLabel.filter(':not(.hidden)').addClass('hidden');
        }
    }

    updateByBasePrices() {
        const mySelf = this;
        this.$basePriceSelects.each(function () {
            const $basePriceSelect = $(this);
            mySelf.updateByBasePrice($basePriceSelect);
        });
    }

    updateByBasePrice($basePriceSelect) {
        const currency = $basePriceSelect.data('currency');
        const $specialPriceSelect = this.$element.find('select.special-select[data-currency=' + currency + ']');
        this.updateBySpecialPrice($specialPriceSelect);
        this.checkSpecialAvailable();
    }

    updateBySpecialPrice($specialPriceSelect) {
        const currency = $specialPriceSelect.data('currency');
        const minDiscountPercent = this.$element.data('min-discount-percent');

        const $baseSelect = this.$element.find('select.base-select[data-currency=' + currency + ']');
        const $specialPriceSelectOptions = $specialPriceSelect.find('option');

        const basePrice = parseFloat($baseSelect.find('option:selected').val());
        const selectedPriceString = $specialPriceSelect.find('option:selected').val();

        const selectable = [];
        const notSelectable = [];
        const minDiscountPrice = basePrice * ((100 - minDiscountPercent) / 100);

        let $selected = null;

        $specialPriceSelectOptions.each(function (key, option) {
            const $option = $(option);
            const optionPriceString = $option.val();
            const optionPrice = parseFloat($option.val());

            if (optionPriceString == selectedPriceString) {
                $selected = $option;
            }

            if (optionPrice <= minDiscountPrice) {
                selectable.push(option);
            } else {
                notSelectable.push(option);
            }
        });

        let $selectable = $(selectable);
        let $notSelectable = $(notSelectable);

        if ($selected == null) {
            $selected = $selectable.last();
            $selected.prop('selected', true);
        }

        $notSelectable.prop('selected', false);
        $selectable.not($selected).prop('selected', false);

        $notSelectable.prop('disabled', true);
        $selectable.prop('disabled', false);

        $notSelectable.hide();
        $selectable.show();
    }

    onSpecialSelect(event) {
        const $specialPriceSelect = $(event.currentTarget);

        this.updateBySpecialPrice($specialPriceSelect);
        this.checkSpecialAvailable();
    }

    checkSpecialAvailable() {
        const $minBasePriceSelects = this.$basePriceSelects.filter(function () {
            const $basePriceSelect = $(this);

            return $basePriceSelect.val() > 5;
        });

        const $availableOptions = this.$specialPriceSelects.find('option:not(:disabled)');

        if ($availableOptions.length == 0 || $minBasePriceSelects.length == 0 || $minBasePriceSelects.length != this.$basePriceSelects.length) {
            this.$specialEnableToggle.prop('disabled', true);
            this.$specialEnableToggle.prop('checked', false);
            this.$specialEnableToggle.trigger('change');
            this.$specialMinPriceInfo.removeClass('hidden');
        } else {
            this.$specialEnableToggle.prop('disabled', false);
            this.$specialEnableToggle.trigger('change');
            this.$specialMinPriceInfo.addClass('hidden');
        }
    }

    onBaseSelect() {
        this.updateByBasePrices();
    }

    updatePricePreview($select) {
        let $selectedOption = $select.find('option:selected');
        let multiplier = $select.data('multiplier');
        let prefix = $select.data('prefix');
        let sourceId = $select.attr('id');
        let percentage = $selectedOption.data('percentage');

        let $breakdownDisplay = $('[data-breakdown-display-for =' + sourceId + ']');
        let url = $breakdownDisplay.data('discount-preview-route');

        if (url != undefined) {

            $breakdownDisplay.addClass('pending');

            let token = $('[name=_token]').val();
            let postData = '_token=' + token;
            postData += '&X-CSRF-TOKEN=' + token;
            postData += '&multiplier=' + multiplier;
            postData += '&discount=' + percentage;

            let jqxhr = $.post(url, postData, function () {
            }, 'html')
                .done(function (data) {
                    $breakdownDisplay.removeClass('pending');
                    $breakdownDisplay.html(data);
                })
                .fail(function (data) {

                });
        }
    }

    setDateRange(element) {
        let targetKey = element.data('update-min-date');
        let newMinDate = new Date(element.val());
        let newMaxDate = new Date(newMinDate.getTime() + (60 * 60 * 24 * 30 * 1000));
        let $targetElement = $(targetKey);
        let currentDate = new Date($targetElement.val());

        $targetElement.attr('min', this.formatDate(newMinDate));

        if (currentDate.getTime() < newMinDate.getTime()) {
            $targetElement.val(this.formatDate(newMinDate));
        }

        $targetElement.attr('max', this.formatDate(newMaxDate));

        if (currentDate.getTime() > newMaxDate.getTime()) {
            $targetElement.val(this.formatDate(newMaxDate));
        }
    }

    formatDate(date) {
        let datestring = date.toISOString();
        let dateStringParts = datestring.split('T')
        return dateStringParts[0];
    }

    destroyListener() {
        this.$isLiveToggle.off('change', this.checkPausingPossibleListener);
        this.$isPausedToggle.off('change', this.checkPausingPossibleListener);
        this.$isLiveToggle.off('change', this.updateToggleActiveTextListener);
        this.$isPausedToggle.off('change', this.updateToggleActiveTextListener);
        this.$isLiveToggle.off('change', this.onUpdateIsLiveListener);
        this.$basePriceSelects.off('price-select:changed', this.onBaseSelectListener);
        this.$specialPriceSelects.off('change', this.onSpecialSelectListener);
        this.$minDateSelect.off('change', this.setDateRangeListener);
        this.$savePlanBtn.off('click', this.onSaveClickListener);
        this.$confirmDeactivateNo.off('click', this.onConfirmNoClickListener);
        this.$discountSelect.off('change', this.updatePricePreviewListener);
    }
}
